var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberTypeLocationPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 3.75706V8.24019C10.8747 8.37447 10.8383 8.50621 10.7697 8.62164C10.7011 8.73708 10.6028 8.83198 10.485 8.89644L6.36 11.1544C6.24978 11.2153 6.12592 11.2472 6 11.2472C5.87408 11.2472 5.75022 11.2153 5.64 11.1544L1.515 8.89644C1.3972 8.83198 1.29886 8.73708 1.23026 8.62164C1.16166 8.50621 1.1253 8.37447 1.125 8.24019V3.75706C1.1253 3.62278 1.16166 3.49104 1.23026 3.3756C1.29886 3.26017 1.3972 3.16527 1.515 3.10081L5.64 0.842843C5.75022 0.781944 5.87408 0.75 6 0.75C6.12592 0.75 6.24978 0.781944 6.36 0.842843L10.485 3.10081C10.6028 3.16527 10.7011 3.26017 10.7697 3.3756C10.8383 3.49104 10.8747 3.62278 10.875 3.75706Z",
    fill: "#616E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberTypeLocationPartner);
export default __webpack_public_path__ + "static/media/MemberTypeLocationPartner.540e6d7304c632cc6b1fe09280d75807.svg";
export { ForwardRef as ReactComponent };